import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import FontDownloadIcon from "@material-ui/icons/FontDownload";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import backgroundImage from "../../../assets/img/header_sites.png";
import styles from "../../../styles/global-styles.js";
import { SiteService } from "../../../services/site.service";
import { UserService } from "../../../services/user.service.js";
import SiteEdition from "../modals/SiteEdition";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import ProductTableToolbar from "../../shared/table/ProductTableToolbar";
import TableHeadSiteDetail from "../../shared/table/TableHeadSiteDetail";
import { headCellSiteDetail } from "../../stateless/headTables/HeadCellSiteDetail";
import StyleTableRow from "../../../styles/styleTableRow";
import StyledTableCell from "../../../styles/tableCell";
import DeleteEmployeeInSite from "../modals/DeleteEmployeeInSite";
import { Link } from "react-router-dom";

const useStyles = makeStyles(() => ({
  root: { width: "106%" },
  image: {
    maxWidth: "100%",
    width: "100%",
    height: 180,
    minHeight: 130,
    objectFit: "cover",
  },
  paper: {
    height: "auto",
    width: "auto",
    background: "white",
    marginTop: 50,
  },
  title: {
    fontWeight: 700,
    color: "#1C2668",
    opacity: 0.5,
    fontSize: 24,
    padding: 14,
  },
  deleteLink: styles.deleteLink,
  cardInfo: {
    padding: 14,
    display: "inline-flex",
    width: 400,
  },
  rightButton: styles.buttonRightHeader,
  nameSite: {
    color: "#1C2668",
    fontWeight: 600,
    position: "absolute",
    top: "180px",
    marginLeft: 40,
  },
  backLink: styles.backLink,
}));

const SiteDetail = ({
  match: {
    params: { id },
  },
  addAlert,
  detailAlert,
}) => {
  const [detailSite, setDetailSite] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDistribModal, setOpenDistribModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [employees, setEmployees] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    loadSite();
    getUsersBySite();
  }, []);

  const loadSite = async () => {
    try {
      const { data } = await SiteService.getSiteById(id);
      if (data.length) setDetailSite(data[0]);
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs,
      });
    }
  };

  const getUsersBySite = async () => {
    try {
      console.log("id recover", id);
      const { data } = await UserService.getUsersBySiteId(id);
      console.log("sitesById", data);
      setEmployees(data);
    } catch (error) {
      console.log(error);
      addAlert({ showAlert: true });
      detailAlert({ severity: "error", message: error.msgs });
    }
  };

  const handleEditSite = (result, message) => {
    addAlert({ showAlert: true });
    setOpenModal(false);
    if (result) {
      loadSite();
      detailAlert({
        severity: "success",
        message: "Sucursal actualizada exitosamente",
      });
    } else {
      console.log("message", message);
      detailAlert({
        severity: "error",
        message: message ? message : "Error al actualizar sucursal",
      });
    }
  };

  const handleCloseEditModal = () => {
    setOpenModal(false);
  };

  const handleSelectAllEmployees = (event, state) => {
    if (event.target.checked) {
      const newSelected = state.map((n) => n.id);
      return newSelected;
    }
    return [];
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleClick = (event, userId) => {
    const selectedIndex = selected.indexOf(userId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, userId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleDeleteEmployee = async () => {
    addAlert({ showAlert: true });
    try {
      const { data, status } = await UserService.deleteUser(id);
      console.log("delete", data);
      if (status === 200) {
        detailAlert({
          severity: "success",
          message: "Empleado eliminado exitosamente",
        });
      }
    } catch (error) {
      detailAlert({
        severity: "error",
        message: error.msgs,
      });
    }
  };

  return (
    <Fragment>
      <div className={classes.root}>
        <Typography variant="h4" component="h4" className={classes.nameSite}>
          {detailSite.name}
        </Typography>
        <Typography variant="body1" component={"div"}>
          <Link to="/dashboard/sucursales" className={classes.backLink}>
            {"<"} Sucursales
          </Link>
        </Typography>
        <img src={backgroundImage} className={classes.image} alt="" />

        <Grid container direction="row" spacing={4}>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Paper className={classes.paper}>
              <Typography variant="h4" component="h4" className={classes.title}>
                Detalles
              </Typography>
              <div className={classes.cardInfo}>
                <HomeIcon color="primary" />
                <Typography
                  variant="body1"
                  component={"span"}
                  style={{ marginLeft: 30 }}
                >
                  {detailSite.name}
                </Typography>
              </div>
              <div className={classes.cardInfo}>
                <ContactMailIcon color="primary" />
                <Typography
                  variant="body1"
                  component={"span"}
                  style={{ marginLeft: 30 }}
                >
                  {detailSite.direction}
                </Typography>
              </div>
              <div className={classes.cardInfo}>
                <RoomOutlinedIcon color="primary" />
                <Typography
                  variant="body1"
                  component={"span"}
                  style={{ marginLeft: 30 }}
                >
                  {detailSite.cp}
                </Typography>
              </div>
              <div className={classes.cardInfo}>
                <FontDownloadIcon color="primary" />
                <Typography
                  variant="body1"
                  component={"span"}
                  style={{ marginLeft: 30 }}
                >
                  {detailSite.serie}
                </Typography>
              </div>
              <div style={{ textAlign: "center" }}>
                <Button
                  style={{ margin: "30px 0" }}
                  className={classes.rightButton}
                  onClick={() => setOpenModal(true)}
                  variant="contained"
                  color="primary"
                  endIcon={<SettingsOutlinedIcon color="secondary" />}
                >
                  Editar detalles
                </Button>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <Paper className={classes.paper}>
              <div style={{ display: "inline-flex" }}>
                <Typography
                  variant="h4"
                  component="h4"
                  className={classes.title}
                >
                  Lista de empleados
                </Typography>
                <Button
                  disabled={!selected.length}
                  style={{ margin: "10px 20px" }}
                  className={classes.rightButton}
                  variant="contained"
                  onClick={() => setOpenDistribModal(true)}
                  color="primary"
                  endIcon={<EditIcon color="secondary" />}
                >
                  Transferir empleado(s)
                </Button>
                <Button
                  disabled={!selected.length}
                  style={{ margin: "10px 20px" }}
                  className={classes.rightButton}
                  variant="contained"
                  onClick={() => setOpenDeleteModal(true)}
                  color="primary"
                  endIcon={
                    <DeleteOutlinedIcon
                      color="secondary"
                      style={{ fontSize: 25 }}
                    />
                  }
                >
                  Eliminar empleado(s) {}
                </Button>
              </div>
              <ProductTableToolbar
                productsSelected={selected}
                label={" usuario(s) seleccionados"}
              />
              <TableContainer style={{ marginTop: 20 }}>
                {employees.length > 0 && (
                  <Table
                    className={classes.table}
                    size={"medium"}
                    aria-label="collapsible table"
                  >
                    <TableHeadSiteDetail
                      numSelected={selected.length}
                      headCells={headCellSiteDetail}
                      onSelectAllClick={(e) =>
                        setSelected(handleSelectAllEmployees(e, employees))
                      }
                      rowCount={employees.length}
                    />
                    <TableBody>
                      {employees.map((employee, index) => {
                        const isItemSelected = isSelected(employee.id);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <StyleTableRow
                            hover
                            onClick={(event) => handleClick(event, employee.id)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={index}
                            className={classes.rowSelected}
                            selected={isItemSelected}
                          >
                            <StyledTableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                                color="primary"
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {employee.name}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {employee.email}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {employee.telephone}
                            </StyledTableCell>
                          </StyleTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </div>
      {/**TODO validar con cliente bajo que condiciones se puede eliminar sucursal 
       *  <div style={{ display: "inline-flex", marginTop: 10 }}>
        <ClearIcon htmlColor="red" />
        <Typography
          variant="body1"
          component={"div"}
          className={classes.deleteLink}
        >
          Eliminar sucursal
        </Typography>
      </div>
      */}

      {openModal && (
        <SiteEdition
          info={detailSite}
          id={id}
          updateDirection={handleEditSite}
          open={openModal}
          onClose={handleCloseEditModal}
        />
      )}
      {openDeleteModal && (
        <DeleteEmployeeInSite
          open={openDeleteModal}
          confirm={handleDeleteEmployee}
          closeDialog={() => setOpenDeleteModal(false)}
        />
      )}

      {/* openDistribModal && (

      ) */}
    </Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(SiteDetail);
